import { cn } from '@brew/ui/cn'
import type { ReactNode } from 'react'
import { HEADER_HEIGHT_CLASS } from '@/lib/shared/layout-constants'

/**
 * The app header's frame: the title cluster on the left, the actions on
 * the right, one header height and the bottom rule the chat panel's header
 * row meets across the panel edge. `AppHeader` fills it from the page title
 * context and the live controls; the product demo fills it with the same
 * crumb and buttons, unconnected. A leaf: a loading shell can reserve the
 * row without the header's client controls.
 */
export function AppHeaderBar({
  leading = null,
  actions = null,
  hasRule = true,
  className,
}: {
  leading?: ReactNode
  actions?: ReactNode
  /** The landing page drops the rule so its hero sits on one canvas. */
  hasRule?: boolean
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-between gap-2 bg-background pr-4 pl-3',
        HEADER_HEIGHT_CLASS.height,
        { 'border-border border-b': hasRule },
        className
      )}
    >
      <div className="flex min-w-0 items-center gap-2">{leading}</div>
      <div className="flex shrink-0 items-center gap-2">{actions}</div>
    </div>
  )
}
